var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-table',{attrs:{"columns":_vm.getColumns,"can-update":false,"can-delete":false,"can-search":false,"is-loading":_vm.isLoading,"elements":_vm.pagination.docs,"page":_vm.pagination.page,"total-docs":_vm.pagination.totalDocs,"limit":_vm.pagination.limit,"custom-buttons":[
      {
        variant: 'primary',
        icon: 'eye',
        event: 'openPayment',
      } ]},on:{"sort":_vm.doSort,"pageChanged":_vm.onPageChanged,"openPayment":_vm.onOpenPayment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }